import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const state =
{
    FixedShow : 10,
    urlLink : "http://sir.celex.com.my/storage/viewer/", // this is for online ver
    //urlLink : "/images/viewer/", // hybrid ver content on laptop but data on firebase
    
    idState: { name: "" },

    //ChooseGridView : "", // use for viewing content on ViewAll.vue
    //ChooseContent : '', // use for viewing content on ViewContent.vue

    deviceType: { platform: "", version: ""},
    // currently there are 3 localstorage been use inside code
    // 1. localStorage.getItem('session') -> use for keep user login info
    // 2. localStorage.getItem('book') -> hold last book id that been click 
    // 3. localStorage.getItem('viewAll') -> hold type of magazine that need to be view
}


const store = new Vuex.Store({
    state,
    mutations,
    actions
})
export default store


// WEBPACK FOOTER //
// ./client/store/index.js